import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 9V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3M2 11a2 2 0 1 1 4 0v2h12v-2a2 2 0 1 1 4 0v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2 7v2m16-2v2"
    }, null, -1)
  ])))
}
export default { render: render }